export const STAGGER_EASE = [0.25, 0.1, 0.25, 1.0] as const
